import React from 'react';
import {MdTextField} from 'core/components/fields/fields';
import {createForm} from 'core/form/createForm';
import {FieldText, lovLabel, FormProps, ClosedContentProps} from 'core/form/formUtils';
import ProductService from 'product/productService';
import StyledSelect from 'core/components/fields/styledSelect';
import StyledDatePicker from 'core/components/fields/styledDatePicker';
import {BlockComp} from 'core/components/blockComp/blockComp';
import ActiveItem from 'core/components/blockComp/activeItem';
import {Validate} from 'core/form/validate';
import {valid, invalid} from 'core/form/rules';
import {optionsSearch} from "core/common/service/commonDataService";
import {StatusActiveComp, StatusActiveComp__h5_style} from "core/components/buttons/statusActiveComp";
import {observer} from "mobx-react";
import {Vehicle} from "product/productDomain";
import Form from "core/form/form";
import {PARTYROLE} from "party/partyDomain";
import {ClosedFormBlock, ClosedFormBlockProps, ClosedFormField} from "core/form/closedForm";
import securityService from "core/security/securityService";
import {RESTRICTION} from "core/security/securityDomain";



function VehicleExistRegistrationNumber({value, vehicleId}: {value: string, vehicleId: number}): any {
  if (!value) return valid();
  return ProductService.vehicleExist({registrationNumber: value, vehicleId})
    .then( (exists) => (exists) ? invalid(`Vehicle with registrationNumber ${value} already exists`) : valid());
}

function VehicleExistVin({value, vehicleId}: {value: string, vehicleId: number}): any {
  if (!value) return valid();
  return ProductService.vehicleExist({vin: value, vehicleId})
    .then( (exists) => (exists) ? invalid(`Vehicle with vin ${value} already exists`) : valid());
}


@observer
class VehicleForm extends React.Component<FormProps<Vehicle, Vehicle>, undefined> {


  render() {


    let {dataObject, rootObject, entity, entities, form} = this.props;
    let fields = form.fields;
    let {registrationNumber, vin, model, vehicleType, vehicleBrand, vehicleNumber, activationDate, party, note, operatorParty,
      lastNotificationCheck, chassisSeries, chassis, driverParty} = fields;

    let hasHaulerVehicle = securityService.currentUser.hasRestriction(RESTRICTION.YARD_MGMT_HAULER_VEHICLE);

    let openContent = (
      <div>

        <div className="row">
          <div className="fx col-xs-12 col-sm-6">
            <StyledSelect  {...party.props} async={true} loadOptions={optionsSearch.bind(this, 'Party', {role: [PARTYROLE.CUSTOMER_ROLE, PARTYROLE.OWNER_ROLE, PARTYROLE.HAULER]})} clearable={true} disabled={hasHaulerVehicle} />
            <Validate field={party} value={party.props.value}  />
          </div>
          <div className="fx col-xs-12 col-sm-6">
            <StyledSelect  {...operatorParty.props} async={true} loadOptions={optionsSearch.bind(this, 'Party', {role: [PARTYROLE.OPERATOR, PARTYROLE.OWNER_ROLE]})} clearable={true} disabled={hasHaulerVehicle} />
          </div>
        </div>
        {/*  2. row  */}
        <div className="row">
          <div className="fx col-xs-6 col-sm-3">
            <MdTextField {...registrationNumber.props} showValidationIcon={true} />
            <Validate field={registrationNumber} value={registrationNumber.props.value}>
              <VehicleExistRegistrationNumber vehicleId={dataObject.vehicleId} />
            </Validate>
          </div>
          <div className="fx col-xs-6 col-sm-3">
            <MdTextField {...vin.props} showValidationIcon={true} />
            <Validate field={vin} value={vin.props.value}>
              <VehicleExistVin vehicleId={dataObject.vehicleId} />
            </Validate>
          </div>
          <div className="fx col-xs-6 col-sm-3">
            <MdTextField {...vehicleNumber.props} />
          </div>
          <div className="fx col-xs-6 col-sm-3">
            <StyledDatePicker {...activationDate.props} />
          </div>
        </div>

        {/*  3. row  */}
        <div className="row">
          <div className="fx col-xs-6 col-sm-3">
            <StyledSelect {...vehicleType.props}  />
            <Validate field={vehicleType} value={vehicleType.props.value}/>
          </div>
          <div className="fx col-xs-6 col-sm-3">
            <StyledSelect {...vehicleBrand.props}  />
            <Validate field={vehicleBrand} value={vehicleBrand.props.value}/>
          </div>
          <div className="fx col-xs-6 col-sm-3">
            <MdTextField {...model.props}  />
          </div>
          <div className="fx col-xs-6 col-sm-3">
            <StyledDatePicker {...lastNotificationCheck.props} />
          </div>
        </div>

        {/*  4. row  */}
        <div className="row">
          <div className="fx col-xs-6 col-sm-3">
            <MdTextField {...chassis.props}  />
          </div>
          <div className="fx col-xs-6 col-sm-3">
            <MdTextField {...chassisSeries.props}  />
          </div>
          <div className="fx col-xs-12 col-sm-6">
            <StyledSelect  {...driverParty.props} async={true} loadOptions={optionsSearch.bind(this, 'Party', {role: [PARTYROLE.DRIVER]})} clearable={true} asterixForAll />
          </div>
        </div>

        {/*  5. row  */}
        <div className="row">
          <div className="fx col-xs-12">
            <MdTextField {...note.props}  />
          </div>
        </div>

      </div>
    );


    return (
      <BlockComp noPadding >
        <ActiveItem openContent={openContent} closedContent={<ClosedContent {...{dataObject, entity, entities, fields}} />} validate={this.props.validate} {...this.props} />
      </BlockComp>
    );
  }
}

const ClosedContent = ({dataObject, entity, entities, fields, disabled}: ClosedFormBlockProps<Vehicle>) => (
  <div>

    <div style={{display: 'flex'}}>
      { disabled ? null :  <StatusActiveComp activeObject={dataObject} entity={entity} id={dataObject.vehicleId} />}
      <h5 style={StatusActiveComp__h5_style}> {lovLabel(dataObject.vehicleBrand)} {dataObject.registrationNumber}</h5>
    </div>

    <ClosedFormBlock {...{dataObject, entity, entities, fields}}>
      { (dataObject.party) ? (<ClosedFormField label='Owner' value={dataObject.party.label} linkProps={{to:'partyDetail', params:{id: dataObject.party.value} }} />) : null}
      { (dataObject.operatorParty) ? (<ClosedFormField label='Operator' value={dataObject.operatorParty.label} linkProps={{to:'partyDetail', params:{id: dataObject.operatorParty.value} }} />) : null}
      { (dataObject.driverParty) ? (<ClosedFormField label='Driver' value={dataObject.driverParty.label} linkProps={{to:'partyDetail', params:{id: dataObject.driverParty.value} }} />) : null}
      <ClosedFormField label={fields.vehicleNumber.textLabel} value={dataObject.vehicleNumber}/>
      <ClosedFormField label={fields.activationDate.textLabel} value={dataObject.activationDate} mdField={fields.activationDate.mdField} />
      <ClosedFormField label={fields.lastNotificationCheck.textLabel} value={dataObject.lastNotificationCheck} mdField={fields.lastNotificationCheck.mdField} />
      <ClosedFormField label={fields.vehicleType.textLabel} value={dataObject.vehicleType}/>
      <ClosedFormField label={fields.model.textLabel} value={dataObject.model}/>
      <ClosedFormField label={fields.vin.textLabel} value={dataObject.vin}/>
      <ClosedFormField label={fields.chassis.textLabel} value={dataObject.chassis}/>
      <ClosedFormField label={fields.chassisSeries.textLabel} value={dataObject.chassisSeries}/>
    </ClosedFormBlock>

    <div className="form-text-row">
      <FieldText value={dataObject.note}/>
    </div>

  </div>
);

const definition = {
  formName: 'VehicleForm',
  fields: [{
    name: 'party'
  },{
    name: 'operatorParty'
  },{
    name: 'driverParty'
  }, {
    name: 'registrationNumber',
    validators: ['IsRequired']
  }, {
    name: 'vin'
  }, {
    name: 'chassis'
  }, {
    name: 'chassisSeries'
  }, {
    name: 'vehicleType',
    validators: ['IsRequired']
  }, {
    name: 'model'
  }, {
    name: 'vehicleBrand',
    validators: ['IsRequired']
  }, {
    name: 'vehicleNumber'
  }, {
    name: 'activationDate'
  }, {
    name: 'note'
  }, {
    name: 'lastNotificationCheck'
  }]
};

export default createForm(definition, ClosedContent)(VehicleForm);




// WEBPACK FOOTER //
// ./src/product/component/vehicleForm.tsx